import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({ providedIn: 'root' })
export class LiveProctorService {
  constructor(public hs: HttpService) {}

  async get_active_sessions(filters: any) { return await this.hs.get('/live-proctor/get-active-sessions', filters); }
  async get_evaluator_detail(user_id: number) { return await this.hs.get('/live-proctor/get-evaluator-detail', { user_id }); }
  async get_ai_triggers(user_id: number) { return await this.hs.get('/live-proctor/get-ai-triggers', { user_id }); }
  async get_proctor_activity(user_id: number) { return await this.hs.get('/live-proctor/get-proctor-activity', { user_id }); }
  async get_proctor_messages(user_id: number) { return await this.hs.get('/live-proctor/get-proctor-messages', { user_id }); }
  async send_proctor_message(to_user_id: number, message: string) { return await this.hs.post('/live-proctor/send-proctor-message', {}, { to_user_id, message }); }
}
